import { ColumnViewModel, LegacyVisibilityModel } from '../shared/column-types';

export function buildVisibilityModel(view: ColumnViewModel): LegacyVisibilityModel {
  return Object.fromEntries(
    view.columns.map(col => [
      col,
      view.defaultVisible.includes(col),
    ]),
  );
}

export function getByViewTab(
  models: Record<string, LegacyVisibilityModel>,
  VIEW: string,
  TAB: string,
  isEvidence: boolean
): LegacyVisibilityModel | undefined {
  const viewType = isEvidence ? 'EVIDENCE' : 'SUMMARY';
  const allKeys = Object.keys(models);

  if (VIEW === 'ALL') {
    const individualTabKey = `${TAB}_ALL`;
    if (models[individualTabKey]) {
      return models[individualTabKey];
    }
  }

  if (VIEW === 'DISEASES' && TAB === 'DISEASES' && !isEvidence && models['DISEASES_ALL']) {
    return models['DISEASES_ALL'];
  }
  if (VIEW === 'GENES' && TAB === 'GENES' && !isEvidence && models['GENES_ALL']) {
    return models['GENES_ALL'];
  }
  if (VIEW === 'VARIANTS' && TAB === 'VARIANTS' && !isEvidence && models['VARIANTS_ALL']) {
    return models['VARIANTS_ALL'];
  }
  if (VIEW === 'CHEMICALS' && TAB === 'CHEMICALS' && !isEvidence && models['CHEMICALS_ALL']) {
    return models['CHEMICALS_ALL'];
  }

  const expectedKey = `${VIEW}_${TAB}_${viewType}`;
  if (models[expectedKey]) {
    return models[expectedKey];
  }

  const matchedKey = allKeys.find(key => 
    key.includes(VIEW) && 
    key.includes(TAB) && 
    key.includes(viewType)
  );

  return matchedKey ? models[matchedKey] : undefined;
}

export function getByMappingName(
  models: Record<string, LegacyVisibilityModel>,
  mappingName: string,
  isEvidence: boolean
): LegacyVisibilityModel | undefined {
  const type = isEvidence ? '_EVIDENCE' : '_SUMMARY';

  const matchedKey = Object.keys(models)
    .filter(key => key.includes(mappingName))
    .filter(key => key.includes(type))[0];

  return matchedKey ? models[matchedKey] : undefined;
}